import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { DeviceInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { DeviceDetailSaveModel } from '../../device-details/models/device-detail-save.model';
import { SaveDevice, SaveDeviceVariables } from '../../device-details/queries/generated/SaveDevice';
import { SaveDeviceMutation } from '../../device-details/queries/save-device.graphql';

@Injectable({ providedIn: 'root' })
export class AddDeviceApiService {
   constructor(private apiService: LcsApiService) {}

   create(deviceDetail: DeviceDetailSaveModel): Observable<ExecutionResult<SaveDevice>> {
      const fields: (keyof DeviceInput)[] = ['deviceTypeId', 'macAddress', 'accountId'];
      return this.apiService.query<SaveDevice, SaveDeviceVariables>({
         query: SaveDeviceMutation,
         variables: {
            device: {
               ...deviceDetail,
               fields: fields,
            },
            deletedHandsetKeysIds: [],
            hasDeletedHandsets: false,
         },
      });
   }
}
